import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  MobileHeader, MobileBottomNav, DesktopHeader 
} from '@/components/layout/MobileLayout';
import { EventDetailsModal } from '@/components/modals/EventDetailsModal';
import { mockEvents } from '@/lib/mockData';
import UserEventList from './UserEventList';

// This component handles deep-link access to event details
// It renders the event list with the modal overlay
export function UserEventDetails() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const event = mockEvents.find(e => e.id === eventId);

  // If event is a past event with recap, redirect to recap
  useEffect(() => {
    if (event?.status === 'past' && event?.hasRecap) {
      navigate(`/events/${eventId}/recap`, { replace: true });
    }
  }, [event, eventId, navigate]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    navigate('/', { replace: true });
  };

  if (!event) {
    navigate('/', { replace: true });
    return null;
  }

  // Render the event list page with modal overlay
  return (
    <div className="min-h-screen bg-background" data-testid="user-event-details">
      {/* Mobile Header */}
      <MobileHeader />
      
      {/* Desktop Header */}
      <DesktopHeader />
      
      {/* Background event list (dimmed) */}
      <main className="pt-14 lg:pt-20 pb-24 lg:pb-12 opacity-30 pointer-events-none">
        <div className="container mx-auto px-4">
          {/* Simplified background content */}
          <div className="h-64 bg-gradient-to-r from-secondary to-card rounded-2xl mb-12" />
          <div className="grid grid-cols-4 gap-6">
            {mockEvents.slice(0, 4).map(e => (
              <div key={e.id} className="aspect-[4/3] bg-card rounded-xl" />
            ))}
          </div>
        </div>
      </main>

      {/* Mobile Bottom Navigation */}
      <MobileBottomNav />

      {/* Event Details Modal */}
      <EventDetailsModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        eventId={eventId}
      />
    </div>
  );
}

export default UserEventDetails;
